import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import configurationStore from '../stores/configuration-store';
import ResultItem from './result-item';

const CLASS_NAME = 'slx-product-wizard-result';
const l = configurationStore.getLocalization.bind(configurationStore);

export default createReactClass({
	displayName: 'ProductWizardResult',

	propTypes: {
		id: PropTypes.string,
		title: PropTypes.string,
		count: PropTypes.number,
		items: PropTypes.array,
		actionNextPage: PropTypes.func,
		actionResetPage: PropTypes.func,
		compositions: PropTypes.array,
		isLoading: PropTypes.bool
	},

	getDefaultProps() {
		return {
			items: []
		};
	},

	onPanelToggle(isSelected) {
		if (isSelected) {
			this.props.actionNextPage();
		} else {
			this.props.actionResetPage();
		}
	},

	moreItems() {
		this.props.actionNextPage();
	},

	render() {
		const title = `${this.props.title} (${this.props.count})`;
		let className = CLASS_NAME;

		if (this.props.isLoading) {
			className += ' loading';
		}

		const items = this.props.items.map((item, index) => {
			item.index = index;
			return <ResultItem item={item} key={item.id} id={item.id} compositions={this.props.compositions} />;
		});

		let more = '';
		if (this.props.items.length > 0 && this.props.count > 0 && this.props.items.length < this.props.count) {
			more = (
				<li className={`${CLASS_NAME}__more`} onClick={this.moreItems}>
					<span>{l('more')}</span>
				</li>
			);
		}

		return (
			<div className={className}>
				<ul className={`${CLASS_NAME}__list`}>
					{items}
					{more}
				</ul>
			</div>
		);
	}
});
